import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BANCOS } from '../../../constants/bancos.constant';
import { MatPaginator } from '@angular/material/paginator';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TaskCaseService } from 'src/app/modules/case/services/taskCase.service';
import { CaseRecordService } from 'src/app/modules/case/services/case-record.service';
import { CasesService } from 'src/app/core/services/cases.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-motivo-del-reclamo',
  templateUrl: './motivo-del-reclamo.component.html',
  styleUrls: ['./motivo-del-reclamo.component.scss'],
})
export class MotivoDelReclamoComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = ['fecha', 'monto', 'canal', 'banco', 'opciones'];
  dataSource = new MatTableDataSource<any>();
  tableValues: any[] = [];

  formTable: FormGroup;
  form: FormGroup;
  submit = false;
  submitFile = false;
  file: File | null;

  @Input() data: { task: any };
  bancosList: any[] = BANCOS;
  canalList: string[] = ['1', '2'];
  constructor(
    private fb: FormBuilder,
    public taskCaseService: TaskCaseService,
    private caseRecordService: CaseRecordService,
    private caseService: CasesService
  ) {}
  icase;
  get status() {
    return this.icase?.status == 'archived';
  }
  ngOnInit(): void {
    let caseId: any;
    if (typeof this.data.task.case == 'object') {
      caseId = this.data.task.case._id;
    } else if (typeof this.data.task.case == 'string') {
      caseId = this.data.task.case;
    }

    this.caseService.getCase(caseId).subscribe((res) => {
      this.icase = res;
    });
    const { task } = this.data;
    const values = task.data ? task.data : [];

    this.tableValues = values.obs ? values.obs : [];
    this.formTable = this.fb.group({
      fecha: ['', [Validators.required]],
      // observacion: ['', [Validators.required]],
      monto: ['', [Validators.required]],
      canal: ['', [Validators.required]],
      banco: ['', [Validators.required]],
    });
    this.form = this.fb.group({
      obs: [values ? values : null],
    });

    this.initializeTable();
  }

  verificateInput(value: string) {
    return (
      this.formTable.get(value)?.invalid &&
      (this.formTable.get(value)?.dirty || this.formTable.get(value)?.touched)
    );
  }

  addData() {
    if (this.formTable.invalid || this.submit) return;
    this.submit = true;
    this.tableValues.unshift(this.formTable.value);
    this.form.value.obs = this.tableValues;
    this.formTable.reset();
    this.initializeTable();
    this.taskCaseService
      .updateTaskCase(this.data.task._id, { data: this.tableValues }) //TODO colocar el last user
      .subscribe(
        (caseUpdated) => {
          this.formTable.reset();
          this.initializeTable();
          this.taskCaseService.taskUpdated.next({ task: caseUpdated });
          this.caseRecordService.updatedRecord.next(true);
        },
        (erorr) => {
          this.submit = false;
        }
      );
  }

  removeData(index: number) {
    this.tableValues.splice(index, 1);
    this.form.value.tableValues = this.tableValues;
    this.taskCaseService
      .updateTaskCase(this.data.task._id, { data: this.tableValues }) //TODO colocar el last user
      .subscribe(
        (caseUpdated) => {
          this.formTable.reset();
          this.initializeTable();
          this.taskCaseService.taskUpdated.next({ task: caseUpdated });
          this.caseRecordService.updatedRecord.next(true);
        },
        (erorr) => {
          this.submit = false;
        }
      );
  }

  initializeTable() {
    this.dataSource = new MatTableDataSource<any>(this.tableValues);
    this.dataSource.paginator = this.paginator;
    this.submit = false;
    this.submitFile = false;
  }
}
